import { useId, useState } from "react"
import { translate } from "../app"
import { translations } from "../translations"

const CONTACT_EMAIL = "SCSL@Rescue.org"

/** One quiet line under the chat that expands into the full terms on demand. */
export function AiDisclaimerNote() {
  const [open, setOpen] = useState(false)
  const panelId = useId()

  return (
    <div className="chat-note">
      <div className="chat-note__row">
        <span className="chat-note__text">{translate(translations.aiDisclaimerShort)}</span>
        <button
          type="button"
          className="chat-note__toggle"
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((o) => !o)}
        >
          {translate(translations.aiDisclaimerLabel)}
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            aria-hidden="true"
            focusable="false"
            className={`chat-note__chevron ${open ? "is-open" : ""}`}
          >
            <path d="M2 3.5 5 6.5 8 3.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
          </svg>
        </button>
      </div>
      {open && (
        <div id={panelId} className="chat-note__body">
          <p>{translate(translations.aiDisclaimerUse)}</p>
          <p>{translate(translations.aiDisclaimerData)}</p>
          <p>
            {translate(translations.aiDisclaimerContact)}{" "}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </p>
        </div>
      )}
    </div>
  )
}
